import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/api";

export const Seo = ({ title, description, path = "/", jsonLd = [], noindex = false, image = "/img/og-digital-addoctor.jpg", imageAlt = "Freya Jones, SEO and PPC consultant at Digital AdDoctor in Tunbridge Wells", type = "website", raw = false, canonical, ogTitle, children }) => {
  const url = canonical || `${SITE_URL}${path}`;
  const full = raw || title?.includes("Digital AdDoctor") ? title : `${title} | Digital AdDoctor`;
  const og = ogTitle || full;
  const img = /^https?:\/\//.test(image) ? image : `${SITE_URL}${image}`;
  useEffect(() => {
    document.querySelectorAll('head [data-rh="true"], #static-title').forEach((n) => n.remove());
  }, []);
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={og} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta name="twitter:title" content={og} />
      {description && <meta name="twitter:description" content={description} />}
      {children}
      {jsonLd.filter(Boolean).map((j, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify({ "@context": "https://schema.org", ...j })}</script>
      ))}
    </Helmet>
  );
};

export const breadcrumbLd = (crumbs) => ({
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${path}` })),
});

export const faqLd = (faqs = []) =>
  faqs.length ? { "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) } : null;

export const PROVIDER = { "@type": "ProfessionalService", "@id": `${SITE_URL}/#business`, name: "Digital AdDoctor" };
